import { z } from "zod";
import { env } from "../../env";
import {
  parseServiceInput,
  parseServiceOutput,
  requestConfig,
} from "../../globals";
import { type AccountProfile, accountProfile } from "../schemas/accountProfile";
import { accountProfileInput } from "../schemas/accountProfile.input";

export const updateAccountProfileProps = z
  .object({ token: z.string(), accountProfile: accountProfileInput })
  .extend(requestConfig.shape);

export type UpdateAccountProfileProps = z.infer<
  typeof updateAccountProfileProps
>;

export const updateAccountProfile = async (
  args: UpdateAccountProfileProps,
): Promise<AccountProfile> => {
  const {
    endpoint = env.ACCOUNT_SERVICE_URL,
    token,
    accountProfile: profileInput,
    proxyAuthSecret,
  } = parseServiceInput(updateAccountProfileProps, args);

  const headers = new Headers({
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`,
    ...(proxyAuthSecret && { "X-NG-Proxy-Auth": proxyAuthSecret }),
  });

  const response = await fetch(`${endpoint}/v1/account/profile`, {
    method: "PUT",
    headers,
    body: JSON.stringify(profileInput),
  });

  return parseServiceOutput(response, accountProfile, {
    code: "MALFORMED_ACCOUNT_PROFILE",
    message: "Account profile is malformed",
  });
};
